module.exports = __webpack_public_path__ + "static/img/img-sreen01.5284937.jpg";